import $ from "jquery";
import "plugin_wishlists/main";

import { createIcons, icons } from "lucide";

// Components
import initializeExperienceComponents from "./experience/index";
import initComponents from "./components";
import minicart from "./components/miniCart";
import search from "./components/search";
import vehicleSelector from "./components/vehicleSelector";
import searchSuggestions from "./components/searchSuggestions";
import checkoutProgressBar from "./components/checkoutProgressBar";

$(() => {
    // Initial Ford JS Client-side code
    initializeExperienceComponents();
    initComponents();
    minicart();
    search();
    vehicleSelector();
    searchSuggestions();
    createIcons({ icons });
    checkoutProgressBar();
});
